<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetKostenuebernahme"></a>
      <h3>
        <i class="icon-kostenuebernahme"></i> <span i18n>Kostenübernahme</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <app-reisekosten
            (andereValueChanged)="andereValueChangedHandler()"
            formControlName="reisekostenUebernahme"></app-reisekosten>
          <app-verpflichtungserklaerungsgeber
            formControlName="verpflichtungserklaerungsgeber"
            [andereValueChecked]="this.form.value.reisekostenUebernahme.organisation"
            [verpflichtungserklaerungsgeberListItems]="this.verpflichtungserklaerungsgeberListItems"
            *ngIf="this.form.value.reisekostenUebernahme && this.form.value.reisekostenUebernahme.organisation === true"></app-verpflichtungserklaerungsgeber>
        </div>
      </div>
    </div>
  </div>
</div>
